// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-calendars,
.department-schedules {
  width: 650px;
}

.department-calendars--wrapper,
.department-schedules--wrapper,
.department-employee-schedule--wrapper {
  width: 670px;
}

.department-calendars--wrapper {
  margin-bottom: 40px;
}

.department-calendars__add,
.department-schedules__add,
.department-employee-schedule__settings {
  margin-right: 20px;
}

/* .detailed-card__input {
  padding: 0.75rem !important;
} */

.detailed-card-errors {
  margin: 0;
  font-size: 12px;
}

.detailed-card__input .p-tabview-panels .show-password-button {
  position: relative;
  align-self: flex-end;
  bottom: 42px;
}

.error-tab .p-tabview-title {
  color: red;
}

.detailed-info-card .p-tabview-title {
  white-space: normal;
  word-break: break-word;
}

.detailed-info-card .p-unselectable-text:first-child .p-tabview-title {
  word-break: keep-all;
}

.detailed-info-card .p-tabview-nav-link {
  height: 100%;
}

.p-tabview-panels:has(.detailedInfo-location-tab) {
  padding-bottom: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/DetailedInformationCard.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".department-calendars,\n.department-schedules {\n  width: 650px;\n}\n\n.department-calendars--wrapper,\n.department-schedules--wrapper,\n.department-employee-schedule--wrapper {\n  width: 670px;\n}\n\n.department-calendars--wrapper {\n  margin-bottom: 40px;\n}\n\n.department-calendars__add,\n.department-schedules__add,\n.department-employee-schedule__settings {\n  margin-right: 20px;\n}\n\n/* .detailed-card__input {\n  padding: 0.75rem !important;\n} */\n\n.detailed-card-errors {\n  margin: 0;\n  font-size: 12px;\n}\n\n.detailed-card__input .p-tabview-panels .show-password-button {\n  position: relative;\n  align-self: flex-end;\n  bottom: 42px;\n}\n\n.error-tab .p-tabview-title {\n  color: red;\n}\n\n.detailed-info-card .p-tabview-title {\n  white-space: normal;\n  word-break: break-word;\n}\n\n.detailed-info-card .p-unselectable-text:first-child .p-tabview-title {\n  word-break: keep-all;\n}\n\n.detailed-info-card .p-tabview-nav-link {\n  height: 100%;\n}\n\n.p-tabview-panels:has(.detailedInfo-location-tab) {\n  padding-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
